import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { RiskMetricId } from "../map/layers/risks";

/**
 * What the Risks pane is currently asking.
 *
 * Two independent questions, kept apart: which peril the commune choropleth is
 * shaded by, and how far back it counts. The window matters more than it looks
 * — a commune that flooded repeatedly until 1995 and one still flooding read
 * identically over the full record and are not the same purchase.
 */
interface RisksState {
  metric: RiskMetricId;
  /** Count only the last twenty years rather than the whole record since 1982. */
  recentOnly: boolean;
  setMetric: (metric: RiskMetricId) => void;
  setRecentOnly: (recentOnly: boolean) => void;

  /** Radius for the live inventory of nearby cavities, plants and sites. */
  radius: number;
  setRadius: (radius: number) => void;
}

export const RADIUS_CHOICES = [500, 1000, 2000];

export const useRisksStore = create<RisksState>()(
  persist(
    (set) => ({
      metric: "inondation",
      recentOnly: false,
      setMetric: (metric) => set({ metric }),
      setRecentOnly: (recentOnly) => set({ recentOnly }),

      radius: 1000,
      setRadius: (radius) => set({ radius }),
    }),
    {
      name: "mete-risks",
      version: 1,
    },
  ),
);
